import React from 'react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import DownloadAction from '@/components/ribbon-actions/DownloadAction';
import { states } from '@/constants/lifecycle';
import download from '@/utils/downloads';
import Selectors from '../hooks/selectors';
import { workspaceRequestSteps } from '../constants';

const WorkspaceRequestWizardActions = ({ code }) => {
  const { activeStepIndex, markdown, saveStatus } = Selectors.useWorkspaceRequestWizardActions({ code });
  const activeStep = Object.values(workspaceRequestSteps)[activeStepIndex].name;

  return (
    <>
      {hasMinimumLength(markdown) && activeStep === workspaceRequestSteps.COMPLETE.name && (
        <DownloadAction
          disabled={saveStatus !== states.SUCCESS}
          onClick={() => download.textDownload(markdown, `${code}_workspace.md`)}
        />
      )}
    </>
  );
};

export default WorkspaceRequestWizardActions;
